import { render } from "./MainLayout.vue?vue&type=template&id=7081fe7e&scoped=true&ts=true"
import script from "./MainLayout.vue?vue&type=script&lang=ts"
export * from "./MainLayout.vue?vue&type=script&lang=ts"

import "./MainLayout.vue?vue&type=style&index=0&id=7081fe7e&scoped=true&lang=css"

import exportComponent from "/home/gitlab-deployer/builds/Bp7u02vYG/0/erp/vuejs-auth/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7081fe7e"]])

export default __exports__